import { AppFormItem, AppFormItemProps, AppBaseSelect, AppBaseSelectProps } from 'components/atoms';
import { SelectOptionType, VatRateType } from 'types';
import { settlementVatRateTypeLabels } from 'consts/settlementVatRates/settlementVatRateLabels';

type VatRatePickerElementProps = AppFormItemProps & Pick<AppBaseSelectProps, 'allowClear'>;

export const varRatePickerOptions: SelectOptionType<VatRateType>[] = [
    {
        label: settlementVatRateTypeLabels.VAT_23,
        value: VatRateType.VAT_23,
    },
    {
        label: settlementVatRateTypeLabels.VAT_8,
        value: VatRateType.VAT_8,
    },
    {
        label: settlementVatRateTypeLabels.VAT_5,
        value: VatRateType.VAT_5,
    },
    {
        label: settlementVatRateTypeLabels.VAT_0,
        value: VatRateType.VAT_0,
    },
    {
        label: settlementVatRateTypeLabels.RELEASED,
        value: VatRateType.RELEASED,
    },
    {
        label: settlementVatRateTypeLabels.NOT_SUBJECT,
        value: VatRateType.NOT_SUBJECT,
    },
];

export const VatRatePickerElement = ({
    allowClear,
    disabled,
    ...props
}: VatRatePickerElementProps) => (
    <AppFormItem disabled={disabled} {...props}>
        <AppBaseSelect options={varRatePickerOptions} disabled={disabled} allowClear={allowClear} />
    </AppFormItem>
);
